import { t } from 'i18next'
import styled from 'styled-components'
import SimpleSwitch from './SimpleSwitch'
import SimpleSwitchContainer from './display/SimpleSwitchContainer'
import { Tooltip } from 'antd'

interface YesNoSwitchProps {
  id?: string
  checked?: boolean
  loading?: boolean
  disabled?: boolean
  onClick?: (value: boolean) => void
  tooltipText?: string
}

const SwitchText = styled.div`
  &.disabled {
    color: var(--colorTextDisabled, rgba(255, 255, 255, 0.25));
  }
`
const YesNoSwitch = ({
  id,
  checked,
  tooltipText,
  ...props
}: YesNoSwitchProps) => {
  const content = (
    <SwitchText
      data-testid={`simple-switch-text-${id}`}
      className={props.disabled ? 'disabled' : ''}
    >
      {checked ? t('Yes') : t('No')}
    </SwitchText>
  )

  return (
    <SimpleSwitchContainer>
      <SimpleSwitch
        data-testid={`simple-switch-${id}`}
        checked={checked}
        {...props}
      />
      {tooltipText && props.disabled ? (
        <Tooltip title={tooltipText}>{content}</Tooltip>
      ) : (
        content
      )}
    </SimpleSwitchContainer>
  )
}

export default YesNoSwitch
